import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import { useMediaQuery } from '@mui/material';

const AccountCard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      width={'100%'}
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        padding: { xs: '64px 24px', sm: '40px 64px', md: '64px' },
        background: theme.palette.darkGrey[50],
        borderRadius: '16px',
        maxHeight: { xs: '376px', sm: '270px', md: '330px' },
      }}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        maxWidth={'768px'}
        width={'100%'}
        alignItems={'center'}
        marginBottom={'32px'}
      >
        <Typography
          variant={isMd ? 'h4' : 'h5'}
          color={theme.palette.darkGrey[700]}
          sx={{
            fontWeight: 700,
            width: '100%',
            letterSpacing: '-0.72px',
            marginBottom: '16px',
            textAlign: { xs: 'left', sm: 'center' },
          }}
        >
          {t('accountCardTitle')}
        </Typography>
        <Typography
          variant={isMd ? 'body2' : 'body3'}
          color={theme.palette.darkGrey[600]}
          sx={{
            fontWeight: 400,
            maxWidth: { xs: '100%', sm: '412px', md: '501px' },
            width: '100%',
            textAlign: { xs: 'left', md: 'center' },
          }}
        >
          {t('accountCardText')}
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} width={'100%'}>
        <Button
          buttontype="orange"
          onClick={() => navigate('/registracija')}
          width={{ xs: '100%', sm: 'auto' }}
        >
          {t('signupNow')}
        </Button>
      </Box>
    </Box>
  );
};

export default AccountCard;
